import { useState } from 'react'
import { uploadFileToPresignedUrl } from '@/modules/operator/api/services'

interface UploadImageOptions {
	onSuccess?: (fileUrl: string) => void
	onError?: (error: unknown) => void
}

interface CreateFileUrlResponse {
	presignedUrl: string
	fileUrl: string
}

interface CreateFileUrlPayload {
	payload: {
		fileExtension: string
	}
}

export const useUploadImage = (
	getUploadFileUrl: (
		params: CreateFileUrlPayload,
	) => Promise<CreateFileUrlResponse>,
) => {
	const [isUploading, setIsUploading] = useState(false)

	const uploadImage = async (
		file: File,
		options?: UploadImageOptions,
	): Promise<string | null> => {
		setIsUploading(true)

		try {
			const fileExtension = file.type.split('/')[1]

			const { presignedUrl, fileUrl } = await getUploadFileUrl({
				payload: { fileExtension },
			})

			await uploadFileToPresignedUrl(presignedUrl, file)

			options?.onSuccess?.(fileUrl)
			setIsUploading(false)
			return fileUrl
		} catch (error) {
			options?.onError?.(error)
			setIsUploading(false)
			return null
		}
	}

	return {
		uploadImage,
		isUploading,
	}
}
